import type { SVGProps } from 'jsx-dom-cjs'

/**
 * Get the SVG tag <use> for the sprite
 * @param options Options
 * @param options.name - SVG name
 * @param options.attributes - SVG attributes
 * @param options.srOnlyText - SVG alternative text
 * @param options.useDefaultAttributes - Whether to use default attributes (aria-hidden, focusable)
 * @returns HTML or HTMLElement for the SVG tag <use>
 */
export default function Svg({
	name,
	attributes = {},
	srOnlyText = '',
	useDefaultAttributes = true
}: {
	name: string
	attributes?: SVGProps<SVGSVGElement>
	srOnlyText?: string
	useDefaultAttributes?: boolean
}) {
	const defaultAttributes: object = {
		'aria-hidden': true.toString(),
		focusable: false.toString()
	}

	// className/class attribute is not supported
	delete attributes.className
	delete attributes.class

	const attributesMerged = useDefaultAttributes
		? Object.assign({}, defaultAttributes, attributes || {})
		: attributes

	const svg = (
		// biome-ignore lint: attributes are set by destructuring (seems not detected)
		<svg className={`icon icon-${name}`} {...attributesMerged}>
			<use href={`#${name}`} />
		</svg>
	)

	if (srOnlyText) {
		return (
			<>
				<span className="sr-only">{srOnlyText}</span>
				{svg}
			</>
		)
	}

	return svg
}
